import React from "react";
import { withTheme } from "styled-components/native";
import Icon from "../icon/FontAwesomePro";
import TextField from "./TextField";

/**
 * Field with a magnifying glass icon to the left of the field.
 */
const SearchField = props => (
  <TextField
    leftComponent={
      <Icon
        name="search"
        color={
          props.color || props.theme.fieldFontColor || props.theme.fontColor
        }
        style={{ marginLeft: 10 }}
      />
    }
    {...props}
  />
);

export default withTheme(SearchField);
